import classnames from 'classnames';
import moment from 'moment';
import React from 'react';

import {ApiAccessSubscription} from 'app/modules/Remote/Organization';
import * as CONSTANTS from 'app/utils/constants';
import {StatusMaybe} from 'app/utils/hookUtils';

import cs from './ContractHistory.module.scss';

export const CurrentPlanSection: React.FunctionComponent<{
  accessSubscriptionMaybe: StatusMaybe<ApiAccessSubscription>;
  hasEnded: (end: string | null) => boolean | '' | null;
  currentLensTier: CONSTANTS.LENS_TIERS_TYPE | undefined;
}> = ({accessSubscriptionMaybe, hasEnded, currentLensTier}) => {
  const formattedRenewalDate = React.useMemo(() => {
    const accessSubscription = accessSubscriptionMaybe.value;
    if (accessSubscription && accessSubscription.endDate && !hasEnded(accessSubscription.endDate)) {
      return `Ends ${moment(accessSubscription.endDate).format('MMMM Do')}`;
    } else if (
      accessSubscription &&
      accessSubscription.currentPeriodEnd &&
      !accessSubscription.endDate
    ) {
      return `Renews ${moment(accessSubscription.currentPeriodEnd).format('MMMM Do')}`;
    }
    return '';
  }, [accessSubscriptionMaybe.value, hasEnded]);

  const isLoading = accessSubscriptionMaybe.status === 'unknown';

  return (
    <div className={cs.planBillingCardSection}>
      <div className={cs.sectionLabel}>Current plan</div>
      {accessSubscriptionMaybe.status === 'error' && (
        <div className={cs.sectionSub}>Couldn't load plan info</div>
      )}
      <div className={classnames(cs.sectionValue, isLoading ? 'bp5-skeleton' : '')}>
        {currentLensTier ? CONSTANTS.LENS_TIER_SETTINGS[currentLensTier].name : '—'}
      </div>
      <div className={classnames(cs.sectionSub, isLoading ? 'bp5-skeleton' : '')}>
        {isLoading ? 'MMM D' : formattedRenewalDate}
      </div>
    </div>
  );
};
